module.exports = __webpack_public_path__ + "img/logo_nufi_blanco-08.2b3ca0a0.svg";